import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=0050dfd2&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./Landing.vue?vue&type=style&index=0&id=0050dfd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0050dfd2",
  null
  
)

export default component.exports